

const getEnvVariables = () => {
    // import.meta.evn;

    // console.log('process.env')
    // console.log(process.env)

    return {
        ...process.env
    }
}

export {
    getEnvVariables
}